import React, { useState, useMemo } from "react";
import { graphql, useStaticQuery } from "gatsby";
import styled from "styled-components";
import { useLocation } from "@reach/router";

const WrapperFooter = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: inherit;
  margin: auto;
  padding: 20px;
  background: ${(props) => props.theme.background};
  border-radius: 20px;

  @media screen and (max-width: 639px) {
    display: block;
    margin-top: 10px;
    margin-bottom: 70px;
  }

  img {
    box-sizing: border-box;
    opacity: 1;
    margin-left: auto;
    margin-right: auto;

    @media screen and (max-width: 640px) {
      width: 200px;
    }
  }

  p {
    font-size: 18px;
    letter-spacing: 0px;
    color: #ffffff;
    text-shadow: inset 0px 1px 6px #00000029;
    border-bottom: 2px solid ${(props) => props.theme.color};

    @media screen and (max-width: 1024px) {
      font-size: 14px;
    }

    @media screen and (max-width: 639px) {
      font-size: 12px;
    }
  }

  .webLogo {
    width: 50px;
    height: 50px;
  }

  .header {
    font-size: 30px;
  }

  .copyright {
    font-size: 18px;
    letter-spacing: 0px;
    color: #ffffff;
    text-shadow: inset 0px 1px 6px #00000029;
    gap: 10px;
    margin-top: 10px;
    width: 100%;
    text-align: right;

    @media screen and (max-width: 1024px) {
      font-size: 14px;
    }

    @media screen and (max-width: 639px) {
      font-size: 12px;
      text-align: left;
    }

    > img {
      width: 30px;

      @media screen and (max-width: 663px) {
        width: 24px;
        object-fit: contain;
      }

      @media screen and (max-width: 459px) {
        width: 18px;
        object-fit: contain;
      }
    }
  }

  .logo_footer {
    width: 150px;
    height: 150px;

    @media screen and (max-width: 1200px) {
      width: 100px;
      height: 100px;
    }

    @media screen and (max-width: 640px) {
      width: 75px;
      height: 75px;
    }
  }
`;

const FooterTheme = {
  live22: {
    background:
      "transparent linear-gradient(180deg, #0396ff 0%, #0080db 100%) 0% 0% no-repeat padding-box",
    color: "#0396ff",
  },
  slotxo: {
    background:
      "transparent linear-gradient(180deg, #E40203 0%, #960E10 100%) 0% 0% no-repeat padding-box",
    color: "#E40203",
  },
  pgslot: {
    background:
      "transparent linear-gradient(180deg, #28BC7B 0%, #3DB741 100%) 0% 0% no-repeat padding-box",
    color: "#28BC7B",
  },
  joker: {
    background:
      "transparent linear-gradient(180deg, #FF12A4 0%, #DA0055 100%) 0% 0% no-repeat padding-box",
    color: "#FF12A4",
  },
  ambslot: {
    background:
      "transparent linear-gradient(180deg, #E59801 0%, #FAEB57 100%) 0% 0% no-repeat padding-box",
    color: "#FFB503",
  },
};

const FooterComponent = () => {
  const { pathname } = useLocation();
  const currentPath = pathname;
  const [currentPage, setCurrentPage] = useState("live22");

  useMemo(() => {
    if (
      [
        "/",
        "/download",
        "/promotion",
        "/credit",
        "/contact",
        "/login",
        "/register",
        "/download/",
        "/promotion/",
        "/credit/",
        "/contact/",
        "/login/",
        "/register/",
      ].includes(currentPath)
    )
      setCurrentPage("live22");
    else setCurrentPage(currentPath.split("/")[1]);
  }, [currentPath]);
  const data = useStaticQuery(graphql`
    query FooterInfo {
      datoCmsCommon {
        lineLogo {
          url
        }
        facebookLogo {
          url
        }
        twitterLogo {
          url
        }
        skypeLogo {
          url
        }
        webLogo {
          url
        }
      }
      datoCmsFooter {
        footerJoker
        footerLive22
        footerPgslot
        footerSlotxo
        footerAmbslot
      }
    }
  `);

  const pageName = currentPage.charAt(0).toUpperCase() + currentPage.slice(1);
  const webLogo = data.datoCmsCommon.webLogo.url;
  const iconSocial = {
    facebook: data.datoCmsCommon.facebookLogo.url,
    twitter: data.datoCmsCommon.twitterLogo.url,
    skype: data.datoCmsCommon.skypeLogo.url,
    line: data.datoCmsCommon.lineLogo.url,
  };
  const footerTitle = data.datoCmsFooter;

  return (
    <WrapperFooter
      theme={FooterTheme[currentPage]}
      className="w-full lg:container mx-auto sm:block"
    >
      <img src={webLogo} alt="" className="logo_footer" />
      <div className="block">
        <div className="header font-extra">
          {pageName.toUpperCase()}
        </div>
        <p
          className="font-normal"
          theme={FooterTheme[currentPage]}
          dangerouslySetInnerHTML={{
            __html: footerTitle[`footer${[pageName]}`],
          }}
        ></p>
        <div className="flex text-left copyright items-center justify-between">
          <div className="inline-flex copyright">
            <img src={iconSocial.facebook} alt="" />
            <img src={iconSocial.twitter} alt="" />
            <img src={iconSocial.skype} alt="" />
            <img src={iconSocial.line} alt="" />
            <div className="w-full">
              <div>Copyright © 2020 kinglive22.com All Rights Reserved.</div>
            </div>
          </div>
        </div>
      </div>
    </WrapperFooter>
  );
};

export default FooterComponent;
